module.exports = __webpack_public_path__ + "static/media/how-it-works-undercarriage-1.cc13e6d9.png";